<template>
    <div>
        <Tab name="5"></Tab>       
        <el-alert :closable="false" type="warning" show-icon>
            该页面显示的是TDC账号：xuexiaojie@taihe.com的快链数据
        </el-alert>
		<div class="page-filter-box MT10">
		    <el-row :gutter="20">
		        <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
		            <el-date-picker
		                v-model="datetimerange"
		                type="daterange"
		                range-separator="-"
		                start-placeholder="开始日期"
		                end-placeholder="结束日期"
		                size="small"
		                value-format="yyyy-MM-dd"
		                :clearable="false"
		                style="width:100%"
		                unlink-panels
		                >
		            </el-date-picker>
		        </el-col>
		        <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		            <el-button type="primary" icon="el-icon-download" @click="download" :loading="downLoading" size="small" v-if="$utils.have('/tdc/downloadPageList')">导出</el-button>
					<el-button v-if="$utils.have('/shortUrl/save')" type="primary" icon="el-icon-plus" size="small"
					    @click="$refs.editTpl.show()">创建TDC短链</el-button>
		        </el-col>
		    </el-row>
		</div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="dataLoading" size="small" stripe>
                <el-table-column label="快链" prop="shortUrl"></el-table-column>
                <el-table-column label="原始链接" prop="ulr" min-width="160"></el-table-column>
                <el-table-column label="最近7天访问">
                    <template slot-scope="scope">
                        <p>PV:{{ scope.row.pv7 }}</p>
                        <p>UV:{{ scope.row.uv7 }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime"></el-table-column>
                <el-table-column fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/tdc/detail')" type="text" size="small"
                            icon="el-icon-s-management" @click="details(scope.row)">查看数据</el-button>
                        <el-button v-if="$utils.have('/shortUrl/save')" type="text" size="small" icon="el-icon-edit"
                            @click="$refs.editTpl.show(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <Details ref="details" @onUpdate="getDataList"></Details>
        <edit ref="editTpl" @onUpdate="getDataList()"></edit>
    </div>
</template>

<script>
import Details from '../components/details.vue'
import Edit from "./components/Edit.vue";
import Tab from "../components/tab";
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
	startTime:'',
	endTime:''
}
export default {
    components: { Tab, Details, Edit },
	
    data() {
		
        return {
            dataLoading: false,
            dataList: null,
            data: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
			datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
			downLoading:false
        }
    },
    mounted() {
        this.getDataList()
    },
    methods: {
        //获取列表
        getDataList() {
            this.dataLoading = true;
            this.$request({
                url: "/tdc/pageList",
                method: "POST",
                data: {
                    ...this.params,
					startTime:this.datetimerange && this.datetimerange[0] || null,
					endTime:  this.datetimerange && this.datetimerange[1] || null
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result?.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
			this.datetimerange = [];
            this.params = {
                ...this.params
            };
            this.getDataList();
        },
        details(data) {
            this.$refs.details.show(data)
        },
		async download(){
			this.downLoading = true;
		    let filePath;
		    const res = await this.$request({
		        url:'/tdc/downloadPageList',
		       data: {
		           ...this.params,
				  startTime:this.datetimerange && this.datetimerange[0] || null,
				  endTime:  this.datetimerange && this.datetimerange[1] || null
		       },
		        method: 'post',
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result} = res.data;
		    if(state == 1 && result ){
		        filePath = result.url;
				this.downLoading = false
		    }else{
		        return this.$message.error(msg || '下载失败');
				this.downLoading = false
		    }   
		
		    
			await downloadFileTmp(filePath,'快链数据'+ '.' +this.$utils.getFileType(filePath));
		},

    },

}
</script>
<style lang="scss" scoped></style>